import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'

export const PageLoading: React.FC = () => {
  return (
    <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0 }}>
      <LinearProgress />
    </Box>
  )
}
